import React from 'react'

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from '@mui/material'
import { makeStyles } from 'tss-react/mui'

function FormSwitch({
  marginTop,
  marginBottom,
  checked,
  onChange,
  title,
  helperText,
  disabled = false,
  fullWidth = true,
}: Props) {
  const { classes } = useStyles()

  return (
    <FormControl
      className={fullWidth ? classes.containerFullWidth : ''}
      style={{ marginTop, marginBottom }}
    >
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
        disabled={disabled}
        label={title}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  )
}

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
  title: string
  helperText: string
  marginTop?: number
  marginBottom?: number
  disabled?: boolean
  fullWidth?: boolean
}

const useStyles = makeStyles()(() => ({
  containerFullWidth: {
    width: '100%',
  },
}))

export default FormSwitch
